import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterReport from 'views/partner/reports/betsReport/filterReport'; // Importing FilterReport component
import TableReport from 'views/partner/reports/betsReport/tableReport'; // Importing TableReport component
import TableTransactionsReport from 'views/partner/reports/betsReport/recordTransReport'; // Importing TableTransactionsReport component
import RecordReport from 'views/partner/reports/betsReport/recordReport'; // Importing RecordReport component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * BetsReportView class extends JetView to create a report view for bets.
 */
export default class BetsReportView extends JetView {
    /**
     * Configures the layout of the BetsReportView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const vthis = this; // Reference to the current instance

        const right = {
            // Right section of the layout
            type: 'wide',
            rows: [PlayersView, RecordReport, TableTransactionsReport], // Components in the right section
        };

        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6',
            id: 'toolbar',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh datatable
                            $$('datatable').scrollTo(100, 0); // Scroll to top
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            var table = $$('datatable'); // Reference to the datatable
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // Calculate first record index
                            var last = first + size - 1; // Calculate last record index
                            if (value !== '') {
                                vthis.app.callEvent('export:filter', [
                                    // Trigger export event
                                    { value: value, first: first, last: last },
                                ]);
                            }
                        },
                    },
                },
            ],
        };

        const left = {
            // Left section of the layout
            css: 'int-left',
            rows: [
                FilterReport, // FilterReport component
                { id: 'res2', view: 'resizer' }, // Resizer between components
                TableReport, // TableReport component
                toolbar, // Toolbar component
            ],
        };

        const avanc = {
            // Advanced details accordion
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [
                { id: 'dColl', header: _('Detalles Avanzados'), body: right }, // Right section in accordion
            ],
        };

        const avancResp = {
            // Responsive advanced details accordion
            view: 'accordion',
            multi: true,
            collapsed: true,
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'),
                    body: right,
                    minWidth: 150,
                    on: {
                        onItemClick: function () {
                            // Event handler for item click
                            var height;
                            $(function () {
                                height =
                                    $('.scrolling > .webix_scroll_cont').height() -
                                    $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                if (!$$('dColl').config.collapsed) {
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                } else {
                                    $$('a5').scrollTo(100, 0); // Scroll to top if collapsed
                                    height =
                                        $('.scrolling > .webix_scroll_cont').height() -
                                        $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            // Main layout configuration
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left section
                        { id: 'res', view: 'resizer' }, // Resizer
                        document.body.offsetWidth < 500 ? avancResp : avanc, // Responsive accordion
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the BetsReportView.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width < 500) {
                // Check for mobile screen size
                $$('res').hide(); // Hide resizer
                $$('res2').hide(); // Hide second resizer
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove export dropdown from toolbar
                $$('pagerA').define('group', 1); // Define pager group
            }
            $.fn.scrollBottom = function () {
                // jQuery function to get scroll bottom position
                return $(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}

// FILE DOCUMENTED
